/* eslint-disable no-console */
const LOCAL_STORAGE_SECRET = 'cce-data-portal-2022-';

const getStorage = (mode) => {
  return mode === 'session' ? sessionStorage : localStorage;
};

const getItem = (key, mode = 'session') => {
  try {
    const storage = getStorage(mode);
    return JSON.parse(storage.getItem(`${LOCAL_STORAGE_SECRET}${key}`));
  } catch (ex) {
    return undefined;
  }
};

const removeItem = (key, mode = 'session') => {
  try {
    const storage = getStorage(mode);
    storage.removeItem(`${LOCAL_STORAGE_SECRET}${key}`);
  } catch (ex) {
    console.log(ex);
  }
};

const setItem = (key, value, mode = 'session') => {
  try {
    const storage = getStorage(mode);
    storage.setItem(`${LOCAL_STORAGE_SECRET}${key}`, JSON.stringify(value));
    return undefined;
  } catch (ex) {
    return undefined;
  }
};

export default {
  getItem,
  setItem,
  removeItem,
};
